module.exports = __webpack_public_path__ + "img/photoAlbum4.bfe7b2d3.jpg";